import React, { useEffect, useState } from 'react';
import WidgetContainer from '~/components/WidgetContainer';
import IframeHandler from '~/components/IframeHandler';
import AllIframesComponent from '~/components//AllIframesComponent';
import ProtectedPage from '~/components/security/ProtectedPage';
import {
  Switch,
  Route,
  useRouteMatch,
} from 'react-router-dom';

import ApplicationMenu from '../Menus/components/ApplicationMenu';
import { COMPLIANCE_MIDDLEWARE } from "~/utils/constants";

const Compliance = (props) => {
  const { isMongoOn } = props;
  const [showMenu, setShowMenu] = useState(false);
  let { path } = useRouteMatch();

  useEffect(() => {
    function handleSUEvent(e) {
      console.log(e.detail);
      console.log("constructing menu...")
      setShowMenu(true);
    }

    function handleWaitAppResponse(e) {
      console.log("constructing menu from response...")
      setShowMenu(true);
    }

    window.addEventListener("SUEvent", handleSUEvent);
    window.addEventListener("WaitAppResponse", handleWaitAppResponse);
    /*return () => {
      window.removeEventListener("SUEvent",handleSUEvent, true);
      window.removeEventListener("WaitAppResponse", handleWaitAppResponse, true);
    }*/
  }, [])

  useEffect(() => {
    if (document.getElementById("compliance")) {
      if (document.getElementById("compliance").contentWindow) {
        document.getElementById("compliance").contentWindow.dispatchEvent(new CustomEvent("GetAppResponse", { detail: 'from: compliance' }))
        console.log("after disptaching GetAppResponse to iframe compliance")
      }
    }
  })

  return (
    <>
      <AllIframesComponent name="compliance" />
      <Switch>
        <Route path={`${path}/tarefas`}>
          <ProtectedPage roles={["ADMIN", "ComplianceUser"]}>
            <IframeHandler name="compliance" />
          </ProtectedPage>
        </Route>
        <Route path={`${path}/processos`}>
          <ProtectedPage roles={["ADMIN", "ComplianceUser"]}>
            <IframeHandler name="compliance" />
          </ProtectedPage>
        </Route>
        <Route path={`${path}/pesquisar`}>
          <ProtectedPage roles={["ADMIN", "ComplianceUser"]}>
            <IframeHandler name="compliance" />
          </ProtectedPage>
        </Route>
        <Route path={path}>
          <ProtectedPage roles={["ADMIN", "ComplianceUser"]}>
            <>
              <ApplicationMenu
                applicationName={COMPLIANCE_MIDDLEWARE.context}
                showMenu={showMenu}
              />
              {isMongoOn &&
                <WidgetContainer />
              }
            </>
          </ProtectedPage>
        </Route>
      </Switch>
    </>
  )
}
export default Compliance
